export default __webpack_public_path__ + "static/media/Python.b8e669ff.webp";